import { useReactFlow } from "reactflow";

const useFitView = () => {
  const { fitView, getViewport, setViewport } = useReactFlow();

  const handleFitView = () => {
    try {
      const { zoom } = getViewport();

      setTimeout(() => {
        fitView({ duration: 400 });
        setTimeout(() => {
          const { x, y } = getViewport();
          setViewport({ x, y, zoom });
        }, 300);
      }, 200);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleFitView
  };
};

export default useFitView;
